<template>
  <div class="home">
    <b-container>
      <div class="mb-4">
        <h1>
          Welcome to VaxCheck!
        </h1>
        <strong>
          VaxCheck allows for the collection of consent to view immunization information from the Minnesota Immunization
          Information Connection (MIIC).
        </strong>
        <p>
          <ul>
            <li>
              Employers can use this to collect consent from employees.
            </li>
            <li>
              Certified child care centers can use this to collect consent from parents/guardians for enrolled children.
            </li>
          </ul>
        </p>
      </div>
      <div>
        <p>
          If you are a returning user, select Log in.
        </p>
        <b-row>
          <b-col>
            <b-button class="landing-btn" @click="login" role="button">
              <strong>Login</strong>
            </b-button>
          </b-col>
        </b-row>
      </div>
      <div class="mt-4 mb-4">
        <p>
          If your organization is not enrolled, select Enroll to start the enrollment process.
        </p>
        <b-row>
          <b-col>
            <b-button class="landing-btn" @click="isEnrollmentChange" role="button">
              <strong>Enroll</strong>
            </b-button>
          </b-col>
        </b-row>
      </div>
      <br>
      <div class="mt-4 mb-4">
        <strong>
          If your organization is already enrolled but you do not have an account, connect with your organization Admin or email the VaxCheck Team at <a href="mailto:Health.VaxCheck@state.mn.us"><u>Health.VaxCheck@state.mn.us</u></a>.
        </strong>
      </div>
      <div class="mt-4 mb-4">
        <footer>
          <div class="mt-5">
            <hr/>
            <div class="fluid-container footer justify-content-center">
              <p class="text-center" style="font-size:.85em;">
            <span>
              For questions email the VaxCheck Team at <a href="mailto:Health.VaxCheck@state.mn.us"><u>Health.VaxCheck@state.mn.us</u></a>.
            </span><br/>
                <span>v{{appVersion}}</span>
              </p>
            </div>
          </div>
        </footer>
      </div>
    </b-container>
  </div>
</template>

<script>
import axios from "axios"
import axiosRetry from 'axios-retry'
import router from "@/router";
import {version} from '../../package.json';

axiosRetry(axios, {retries: 3, retryDelay: axiosRetry.exponentialDelay})

export default {
  data: () => ({
    isEnrollment: false
  }),

  methods: {
    login() {
      window.location.replace('/home')
    },
    register() {
      const registerUrl = this.$keycloak.registerUrl
      window.location.replace(registerUrl)
    },
    isEnrollmentChange() {
      router.push('requestAccess')
    },

  },
  computed: {
    appVersion: function() {
      return version;
    }
}
}
</script>

<style scoped>
li {
  display: list-item !important;
}

.landing-btn {
  background-color: rgb(0, 56, 101);
  width: 10em;
}
ul {
  list-style-type: disc !important;
  padding-left: 1em;
}
</style>
